import { useTranslation } from "react-i18next";
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import { FormInstance } from "antd/lib";
import { FunctionComponent } from "react";
import "./filter-group.scss";
// import { dataStatus } from '../../../pages/list-user/constants/data';

import { FilterData } from "./filter";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";

type FormFilterProps = {
  handleCloseFilter: () => void;
  tab: string;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  setFilterData: (dateString: string[], planCreationDate: string) => void;
  dataOptions?: any;
  filterData: any;
};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  handleCloseFilter,
  onFinish,
  form,
  showFilter,
  clearFilter,
  dataOptions,
  filterData,
  setFilterData,
  tab,
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const listStatus = [
    ...(tab === '2' ?
      [{
        id: 1,
        name: t("Chờ xuất bản", "Chờ xuất bản")
      }]
      : [{
        id: 2,
        name: t("Chờ tổ chuyên môn duyệt", "Chờ tổ chuyên môn duyệt")
      }]
    )
  ]

  const courseType = [
    { id: 1, name: t("Tự triển khai", "Tự triển khai") },
    { id: 2, name: t("Hợp tác xây dựng", "Hợp tác xây dựng") },
    { id: 3, name: t("Dùng chung", "Dùng chung") },
  ];

  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}>
            <Col
              xl={{ span: 5 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Trạng thái", "Trạng thái")}</Typography.Title>
              <Form.Item name="status">
                <FormItemDropdown placeholder={t("Trạng thái", "Trạng thái")} onChange={(option) => setFilterData(option, 'status')}
                  modeDropdown="multiple"
                  options={listStatus} />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{t("Loại khoá học", "Loại khoá học")}</Typography.Title>
              <Form.Item name="courseType">
                <FormItemDropdown placeholder={t("Loại khoá học", "Loại khoá học")} onChange={(option) => setFilterData(option, 'courseType')}
                  modeDropdown="multiple"
                  options={courseType} />
              </Form.Item>
            </Col>
            <Col
              xl={{ span: 4 }}
              md={{ span: 5 }}
              sm={{ span: 5 }}
              xs={{ span: 24 }}
            >
              <Typography.Title level={5}>{tab === "1" ? t("Ngày gửi", "Ngày gửi") : t("Ngày", "Ngày")}  {t("phê duyệt", "phê duyệt")}</Typography.Title>
              <Form.Item name="approvedDate">
                <RangePicker
                  placeholder={[t("Từ ngày", "Từ ngày"), t("Đến ngày", "Đến ngày")]}
                  format="DD-MM-YYYY"
                  value={filterData.approvedDate}
                  onChange={(_value, dateString: any) =>
                    setFilterData(dateString, "approvedDate")
                  }
                />
              </Form.Item>
            </Col>

            <Col
              xl={{ span: 3 }}
              md={{ span: 9 }}
              sm={{ span: 9 }}
              xs={{ span: 24 }}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                  onClick={() => form.submit()}
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;